export default __webpack_public_path__ + "static/media/customizetags.1a6bf182.svg";